import type { ApiError } from "@circle-react/config/CustomErrors";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useState } from "react";
import { useQuery } from "react-query";

interface AccountPaymentProcessorInvoiceType {
  hosted_invoice_url: string;
}

export const useLatestInvoice = () => {
  const [shouldRetrieveInvoice, setShouldRetrieveInvoice] = useState(false);

  const onRetrieveLatestInvoice = () => {
    setShouldRetrieveInvoice(prev => !prev);
  };

  const { data: latestInvoice, isInitialLoading: isLoadingInvoice } = useQuery<
    AccountPaymentProcessorInvoiceType,
    ApiError
  >({
    queryKey: [internalApi.accountPaymentProcessors.invoice.show()],
    enabled: shouldRetrieveInvoice,
  });

  return {
    latestInvoice,
    isLoadingInvoice,
    onRetrieveLatestInvoice,
    shouldRetrieveInvoice,
  };
};
